import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
export const useSubmitData = (axiosInstance, endpoint, navigateList, lastFunction = null) => {
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();
  const navigate = useNavigate();
  return async (data) => {
    try {
      await axiosInstance.post(endpoint, data);
      enqueueSnackbar(t("createMessageSuccess"), { variant: "success" });
      navigate(navigateList);
      if (lastFunction) {
        lastFunction(0)
      }

    } catch (err) {
      if (err?.response?.status === 409) {
        // enqueueSnackbar(err?.response?.data, { variant: "error" });
        enqueueSnackbar("Error: Status "+err?.response?.status, { variant: "error" });
      }
      else if (err?.response?.status === 400) {
        enqueueSnackbar("Error: Status "+err?.response?.status , { variant: "error" });
      }
      else {
        enqueueSnackbar(t("createMessageError"), { variant: "error" });
      }
    }
  };
};
